'use strict';

/**
 * @ngdoc function
 * @name myConsultApp.controller:administrativeDashboardCtrl
 * @description
 * # administrativeDashboardCtrl
 * Controller of the myConsultApp
 */
angular.module('myConsultApp').controller('administrativeDashboardCtrl', ($scope, $location) => {
  if (!$scope.isAdminUser && !$scope.isSuperUser) {
    $location.path('/find-a-pet');
  }
});
